import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth-store';
import type { ReactNode } from 'react';

// =============================================================================
// RoleGuard: proteksi route per-level (level_id). Dipakai DI DALAM AuthGuard
// (token sudah dipastikan ada). Kalau level_id user tidak termasuk `levels`,
// redirect ke `fallback` (default /monitoring) — sehingga user non-admin yang
// mengetik URL admin langsung (mis. /tenants) tidak nyangkut di halaman kosong.
//
// CATATAN: ini lapis UX. Enforcement keamanan TETAP di backend (api-server
// adminOnly/canViewUser) — RoleGuard hanya mencegah render halaman yang tak
// relevan, bukan pengganti otorisasi server.
//
// level_id: 1=admin, 2=operator, 3=viewer, 4=reseller (lihat lib/auth.ts).
// =============================================================================

export function RoleGuard({
  levels,
  fallback = '/monitoring',
  children,
}: {
  levels: number[];
  fallback?: string;
  children: ReactNode;
}) {
  const level = useAuthStore((s) => s.claims?.level_id);
  if (level == null || !levels.includes(level)) {
    return <Navigate to={fallback} replace />;
  }
  return <>{children}</>;
}
